module.exports = __webpack_public_path__ + "media/images/logo/logo_white-0aea2860277ca15d72d2d4d98c1585c4.png";